var BACKEND_STATUS = 'backendStatus';

/**
 * Starts loading pipeline status from the API.
 */
var BACKEND_STATUS_LOADING = "".concat(BACKEND_STATUS, "/backendStatusLoading");

/**
 * Loaded pipeline status from the API.
 */
var BACKEND_STATUS_LOADED = "".concat(BACKEND_STATUS, "/backendStatusLoaded");

/**
 * Backend status update was received.
 */
var BACKEND_STATUS_UPDATED = "".concat(BACKEND_STATUS, "/backendStatusUpdated");

/**
 * Error state when backend status could not be loaded from the API.
 */
var BACKEND_STATUS_ERROR = "".concat(BACKEND_STATUS, "/backendStatusError");

/**
 * A work request was submitted and the API said which of the experiment's workers took it.
 */
var WORKER_TASK_REGISTERED = "".concat(BACKEND_STATUS, "/workerTaskRegistered");

/**
 * A heartbeat arrived describing what one of the workers is doing right now. Kept per
 * worker rather than per task: each work queue is FIFO with a single message group, so a
 * worker runs one task at a time and every other task on it is queued behind that one.
 */
var WORKER_STATUS_UPDATED = "".concat(BACKEND_STATUS, "/workerStatusUpdated");
export { BACKEND_STATUS_LOADING, BACKEND_STATUS_LOADED, BACKEND_STATUS_UPDATED, BACKEND_STATUS_ERROR, WORKER_TASK_REGISTERED, WORKER_STATUS_UPDATED };